<template>
  <div>
    <el-row class="parent">
      <el-col :span="24" class="formbg">
        <el-form ref="searchForm" inline :model="searchForm" class="form-search" enctype="multipart/form-data" label-width="110px">
          <el-form-item label="工单编号" prop="id">
            <el-input v-model="searchForm.id" placeholder="工单编号" clearable />
          </el-form-item>
          <el-form-item label="商户编号" prop="merchantNo">
            <el-input v-model="searchForm.merchantNo" placeholder="商户编号" clearable />
          </el-form-item>
          <el-form-item label="任务状态" prop="orderStatus">
            <el-select v-model="searchForm.orderStatus" placeholder="请选择" clearable>
              <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="任务类型" prop="orderType">
            <el-select v-model="searchForm.orderType" placeholder="请选择" clearable>
              <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="发起时间" prop="startingTime">
            <el-date-picker
              style="width: 270px"
              v-model="searchForm.startingTime"
              type="daterange"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            />
          </el-form-item>
          <el-form-item label="操作">
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
            <el-button type="primary" icon="el-icon-search" plain @click="resetFun('searchForm')">清空</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        v-loading="listLoading"
        stripe
        class="common-list"
        :data="tableData"
        element-loading-text="使劲加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        border
      >
        <el-table-column type="index" label="序号" align="center" />
        <el-table-column prop="id" label="工单编号" align="center" width="200px" />
        <el-table-column prop="orderType" label="任务类型" align="center" width="150px">
          <template slot-scope="scope">
            <div v-for="item in orderTypeOptions" :key="item.index">
              <div v-if="scope.row.orderType == item.value">
                {{ item.label }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="任务状态" align="center">
          <template slot-scope="scope">
            <div v-for="item in orderStatusOptions" :key="item.index">
              <div v-if="scope.row.orderStatus == item.value">
                {{ item.label }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="netMerNo" label="商户编号" align="center" width="190px" />
        <el-table-column prop="merchantName" label="注册名称" align="center" width="180px" />
        <el-table-column prop="createUser" label="发起人" align="center" width="180px" />
        <el-table-column prop="organizationName" label="发起人机构" align="center" width="180px" />
        <el-table-column prop="createDate" label="发起时间" align="center" width="160px" />
        <el-table-column prop="updateTime" label="更新时间" align="center" width="160px" />
        <el-table-column prop="step" label="当前步骤" align="center" />
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <el-button v-show="scope.row.orderStatus != '00'" type="text" size="mini" @click="lookBtn(scope)">查看</el-button>
            <el-button
              v-show="scope.row.orderType != '01' && (scope.row.orderStatus == '00' || scope.row.orderStatus == '03')"
              type="text"
              size="mini"
              @click="handleBtn(scope)"
              >办理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="pageNum" :limit.sync="pageSize" @pagination="getDataByPage" />
    </el-row>

    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="lookDialog" width="75%" :close-on-click-modal="false" :before-close="close">
      <div style="line-height: 36px">
        <span>任务编号: {{ orderId }}</span>
        <span style="margin-left: 12px">当前步骤名称: {{ detailStep }}</span>
        <span style="margin-left: 12px">
          任务状态:
          <span v-for="item in orderStatusOptions" :key="item.index">
            <span v-if="orderStatus == item.value">{{ item.label }}</span>
          </span>
        </span>
      </div>
      <merchant-detail :workId="lookWorkId" operatorType="入网查询" />
    </el-dialog>

    <!-- 办理 -->
    <el-dialog title="办理" :visible.sync="handleDialog" width="75%" :close-on-click-modal="false" :before-close="close">
      <merchant-handle operatorType="入网办理" :workId="handleWorkId" :orderStatus="orderStatus" @submitSuccess="submitSuccess"></merchant-handle>
    </el-dialog>
  </div>
</template>

<script>
import { getData } from '@/api/crossborder/merchant/index'
import Pagination from '@/components/Pagination'
import Common from '@/utils/common' // 工具类
import merchantHandle from './merchantHandle'
import merchantDetail from './merchantDetail'
export default {
  components: {
    Pagination,
    merchantHandle,
    merchantDetail,
  },
  data() {
    return {
      lookWorkId: '',
      handleWorkId: '',
      orderStatus: '',

      // 分页
      total: 0,
      pageNum: 1,
      pageSize: 10,
      listLoading: false,

      orderId: '',
      detailStep: '',
      orderStatus: '',
      workOrderVO: {},

      // 任务状态
      orderStatusOptions: [
        {
          value: '00',
          label: '待提交',
        },
        {
          value: '01',
          label: '待审核',
        },
        {
          value: '03',
          label: '驳回',
        },
        {
          value: '04',
          label: '审核通过',
        },
        {
          value: '05',
          label: '预开通',
        },
      ],
      // 任务类型
      orderTypeOptions: [
        {
          value: '10',
          label: '跨境商户进件',
        },
      ],

      searchForm: {
        id: '',
        orderType: '',
        orderStatus: '',
        merchantNo: '',
        merchantName: '',
        startingTime: null,
      },
      tableData: [],

      lookDialog: false,
      handleDialog: false,
    }
  },

  methods: {
    // 查询
    getData() {
      this.pageNum = 1
      this.getDataByPage()
    },

    getDataByPage() {
      const param = Common.setNull({
        ...this.searchForm,
        pageNum: this.pageNum ? this.pageNum : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        platformMerNo: this.$store.getters.merNo,
        craeteTimeStart: this.searchForm.startingTime ? this.searchForm.startingTime[0] : null,
        craeteTimeEnd: this.searchForm.startingTime ? this.searchForm.startingTime[1] : null,
      })
      this.listLoading = true
      getData(param)
        .then((res) => {
          this.tableData = res.data.list
          this.pageNum = res.data.page
          this.total = res.data.total
          this.listLoading = false
        })
        .catch((error) => {
          this.listLoading = false
          console.log(error) // 请求失败返回的数据
        })
    },

    // 当提交成功后，需要重新查询
    submitSuccess() {
      this.close()
      this.getDataByPage()
    },

    // 查看
    lookBtn(scope) {
      this.lookDialog = true
      this.orderId = scope.row.id
      this.detailStep = scope.row.step
      this.orderStatus = scope.row.orderStatus
      this.$nextTick(() => {
        this.lookWorkId = scope.row.id
      })
    },
    // 办理
    handleBtn(scope) {
      this.handleDialog = true
      this.$nextTick(() => {
        this.handleWorkId = scope.row.id
        this.orderStatus = scope.row.orderStatus
      })
    },

    // 关闭弹窗
    close() {
      this.lookWorkId = ''
      this.handleWorkId = ''
      this.orderStatus = ''
      this.lookDialog = false
      this.handleDialog = false
    },

    // 清空筛选项
    resetFun(searchForm) {
      this.$refs[searchForm].resetFields()
      this.searchForm.startingTime = null
    },

    printAll() {},
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/common.scss';
::v-deep .el-select {
  width: 100%;
}
::v-deep .form-search .el-form-item__content {
  width: 270px;
}
::v-deep .el-dialog__body {
  padding: 10px 20px 30px;
}
</style>
